export enum eMySalesPageTab {
	SALES,
	QUESTIONS,
	PUBLICATIONS,
	METRICS,
	CONFIG
}

export enum eMySalesPageTabString {
	SALES = "ventas",
	QUESTIONS = "preguntas",
	PUBLICATIONS = "publicaciones",
	METRICS = "metricas",
	CONFIG = "configuracion"
}

export function MySalesPageTab_stringToNumber(tabString:string|null) : eMySalesPageTab|undefined {
	switch (tabString) {
		case eMySalesPageTabString.SALES : {
			return eMySalesPageTab.SALES;
		}
		case eMySalesPageTabString.QUESTIONS : {
			return eMySalesPageTab.QUESTIONS;
		}
		case eMySalesPageTabString.PUBLICATIONS : {
			return eMySalesPageTab.PUBLICATIONS;
		}
		case eMySalesPageTabString.METRICS : {
			return eMySalesPageTab.METRICS;
		}
		case eMySalesPageTabString.CONFIG : {
			return eMySalesPageTab.CONFIG;
		}
		default : {
			return undefined;
		}
	}
}

export function MySalesPageTab_numberToString(tabNumber:eMySalesPageTab) : eMySalesPageTabString {
	switch (tabNumber) {
		case eMySalesPageTab.SALES : {
			return eMySalesPageTabString.SALES;
		}
		case eMySalesPageTab.QUESTIONS : {
			return eMySalesPageTabString.QUESTIONS;
		}
		case eMySalesPageTab.PUBLICATIONS : {
			return eMySalesPageTabString.PUBLICATIONS;
		}
		case eMySalesPageTab.METRICS : {
			return eMySalesPageTabString.METRICS;
		}
		case eMySalesPageTab.CONFIG : {
			return eMySalesPageTabString.CONFIG;
		}
	}
}
